import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import logo from "./../../../assets/images/logo.png";
import closeIcon from "./../../../assets/icons/close_icon.svg";
import shoppingBagIcon from "./../../../assets/icons/shopping-bag.svg";
import creditCardIcon from "./../../../assets/icons/credit-card.svg";
import logoutIcon from "./../../../assets/icons/logout.svg";
import smChatIcon from "./../../../assets/icons/sm_chat.svg";
import chatSidebarIcon from "./../../../assets/icons/chat.svg";
import userImg from '../../../assets/images/user.png'
import communityIcon from "./../../../assets/icons/sm_community.svg";
import contactIcon from "./../../../assets/icons/sm_contact.svg";
import smLogoutIcon from "./../../../assets/icons/sm_logout.svg";
import smhomeIcon from "./../../../assets/icons/sm_home.svg";
import bannerIcon from "./../../../assets/icons/banners_icon.svg";
import blcakbellIcon from "../../../assets/icons/notification-black-bell-icon.svg";
import bellIcon from "../../../assets/icons/notification-bell.svg";
import productsIcon from "./../../../assets/icons/products_icon.svg";
import serviceSidebarIcon from "./../../../assets/icons/services_icon.svg";
import reportsIcon from "./../../../assets/icons/reports_icon.svg";
import discountsIcon from "./../../../assets/icons/discounts_icon.svg";
import vendorsIcon from "./../../../assets/icons/vendors_icon.svg";
import customersIcon from "./../../../assets/icons/customers_icon.svg";
import supportSidebarIcon from "./../../../assets/icons/support_icon.svg";
import { useSelector, useDispatch } from "react-redux";
import {
  setLoginStatus,
  setUserInfo,
} from "./../../../store/reducers/auth-reducer";
import { authVerification } from "../../../helpers/auth-verification";
import Notifications from "./../../../containers/user/Notifications";
import {
  setCatSearchValue,
  setIsService,
} from "../../../store/reducers/cat-search-reducer";
import io from 'socket.io-client'
import axios from 'axios';
import { NavLink } from "react-router-dom"
import SideMenuLink from "../../common/SideMenuLink";
import InterfaceModeProfileMenuItem from '../../layout/InterfaceModeProfileMenuItem';
import { INTERFACE_MODES } from '../../../helpers/interface-mode';
import { bindHeaderOffcanvasLifecycle, dismissOffcanvasThen } from '../../../helpers/offcanvas-cleanup';
import { Dropdown } from 'bootstrap';
import '../../../assets/css/seller-profile-dropdown.css';

const SELLER_MOBILE_PROFILE_MQ = '(max-width: 991px)';

const dismissOpenOffcanvasThen = (callback) => {
  const sideMenu = document.getElementById('sideMenu');
  const offcanvasNavbar = document.getElementById('offcanvasNavbar');

  if (offcanvasNavbar?.classList.contains('show')) {
    dismissOffcanvasThen('offcanvasNavbar', () => {
      if (sideMenu?.classList.contains('show')) {
        dismissOffcanvasThen('sideMenu', callback);
      } else {
        callback?.();
      }
    });
    return;
  }

  dismissOffcanvasThen('sideMenu', callback);
};

const Header = () => {
  // const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);
  const userInfo = useSelector(state => state.auth.userInfo);
  const authInfo = useSelector(state => state.auth.authInfo);
  const [isToggle, setIsToggle] = useState(false);
  const isService = useSelector((state) => state.catSearch.isService);
  const history = useHistory();
  const dispatch = useDispatch();
  // // const { notifications } = useContext(NotificationContext);
  const [unreadCount, setUnreadCount] = useState(0);
  const mobileProfileDropdownRef = useRef(null);
  const executeLogout = () => {
    localStorage.clear();
    dispatch(setLoginStatus({ isLoggedIn: false }));
    dispatch(setUserInfo({ userInfo: [] }));

    dispatch(setIsService({ isService: 0 }));
    setIsToggle(false);

    history.push('/seller/login');
  };

  const logout = async () => {
    const { unregisterFcmBeforeLogout } = await import('../../../helpers/fcm-logout');
    await unregisterFcmBeforeLogout();
    dismissOpenOffcanvasThen(executeLogout);
  };

  const handleLogoutClick = (event) => {
    event.preventDefault();
    logout();
  };

  useEffect(() => {
    authVerification(dispatch);
  }, [dispatch]);


  useEffect(() => {
    const socket = io.connect(process.env.REACT_APP_SOCKET_SERVER_URL);

    if (authInfo && authInfo.id) {
      socket.emit('allNotifications', { userID: authInfo.id });
      axios.get(`front/notifications/${authInfo.id}`).then(response => {
        const responseData = response.data.data
        if (responseData > 0) {
          const offlineNotifications = responseData.filter(notification => !notification.notification.isRead);
          // offlineNotifications.filter(notification => !notification.isRead);
          if (offlineNotifications && offlineNotifications.length > 0) {
            offlineNotifications.forEach(notification => {
              // Handle the notification
              setUnreadCount((prevCount) => prevCount + 1);
            });
          }
        }
      });
    }


    socket.on('receive_notification', (notification) => {
      if (!notification || !notification.message) {
        console.error('Received invalid notification data:', notification);
        return;
      }

      setUnreadCount((prevCount) => prevCount + 1);
    });

    return () => {
      socket.off('receive_notification');
      socket.disconnect();
    };
  }, [authInfo.id]);

  useEffect(() => bindHeaderOffcanvasLifecycle((path) => history.push(path)), [history]);

  useEffect(() => {
    const trigger = document.getElementById('navbarDropdown');
    const dropdownRoot = trigger?.closest('.seller-profile-dropdown');
    if (!trigger || !dropdownRoot) {
      return undefined;
    }

    const media = window.matchMedia(SELLER_MOBILE_PROFILE_MQ);

    const handleOutsideInteraction = (event) => {
      if (!media.matches) {
        return;
      }

      const menu = dropdownRoot.querySelector('.seller-profile-dropdown__menu');
      if (!menu?.classList.contains('show')) {
        return;
      }

      if (dropdownRoot.contains(event.target)) {
        return;
      }

      mobileProfileDropdownRef.current?.hide();
    };

    const applyProfileTriggerMode = () => {
      if (media.matches) {
        trigger.removeAttribute('data-bs-toggle');
        mobileProfileDropdownRef.current?.dispose();
        mobileProfileDropdownRef.current = Dropdown.getOrCreateInstance(trigger, {
          autoClose: 'outside',
        });
      } else {
        trigger.setAttribute('data-bs-toggle', 'dropdown');
        mobileProfileDropdownRef.current?.dispose();
        mobileProfileDropdownRef.current = null;
      }
    };

    applyProfileTriggerMode();
    media.addEventListener('change', applyProfileTriggerMode);
    document.addEventListener('click', handleOutsideInteraction, true);
    document.addEventListener('touchstart', handleOutsideInteraction, true);

    return () => {
      media.removeEventListener('change', applyProfileTriggerMode);
      document.removeEventListener('click', handleOutsideInteraction, true);
      document.removeEventListener('touchstart', handleOutsideInteraction, true);
      mobileProfileDropdownRef.current?.dispose();
      mobileProfileDropdownRef.current = null;
    };
  }, []);

  const handleNotificationClick = () => {
    axios.put(`front/updateNotifications/${authInfo.id}`).then(response => {
      const offlineNotifications = response.data.data;
    });
    setUnreadCount(0);
  };

  const handleSellerProfileTriggerClick = (event) => {
    event.preventDefault();

    if (window.matchMedia(SELLER_MOBILE_PROFILE_MQ).matches) {
      event.stopPropagation();
      if (!mobileProfileDropdownRef.current) {
        mobileProfileDropdownRef.current = Dropdown.getOrCreateInstance(event.currentTarget, {
          autoClose: 'outside',
        });
      }
      mobileProfileDropdownRef.current.toggle();
    }
  };

  return (
    <React.Fragment>
      <div
        className="offcanvas offcanvas-start side_menu_wrap"
        tabIndex="-1"
        id="sideMenu"
        aria-labelledby="sideMenuLabel"
      >
        <div className="offcanvas-header">
          <button
            type="button"
            className="view_more text-reset"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <img src={closeIcon} className="img-fluid" alt="" /> Close
          </button>
        </div>
        <div className="offcanvas-body">
          <div className="side_menu_body">
            <ul className="side_menu_links">
              <li>
                <SideMenuLink to="/seller/dashboard">
                  <i className="icon">
                    <img src={smhomeIcon} alt="" />
                  </i>
                  Dashboard
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink to="/seller/notifications">
                  <i className="icon">
                    <img src={bellIcon} alt="" />
                  </i>
                  Notifications
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink
                  to="/seller/license"
                >
                  <i className="icon">
                    <img src={vendorsIcon} alt="" />
                  </i>{" "}
                  Seller License
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink
                  to="/seller/earnings"
                >
                  <i className="icon">
                    <img src={reportsIcon} alt="" />
                  </i>{" "}
                  Earnings
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink
                  to="/seller/withdrawal"
                >
                  <i className="icon">
                    <img src={discountsIcon} alt="" />
                  </i>{" "}
                  Earning Calculator
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink
                  to="/seller/stripe-onboarding"
                >
                  <i className="icon">
                    <img src={creditCardIcon} alt="" />
                  </i>{" "}
                  Stripe Onboarding
                </SideMenuLink>
              </li>

              <li>
                <SideMenuLink
                  to="/seller/tax-settings"
                >
                  <i className="icon">
                    <img src={customersIcon} alt="" />
                  </i>{" "}
                  Tax Settings
                </SideMenuLink>
              </li>

              {/* /manage-deals */}
              <li>
                <SideMenuLink
                  to="/seller/manage-deals"
                >
                  <i className="icon">
                    <img src={discountsIcon} alt="" />
                  </i>{" "}
                  Manage Deals
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/manage-advertisement"
                >
                  <i className="icon">
                    <img src={bannerIcon} alt="" />
                  </i>{" "}
                  Manage Advertisements
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/listed-items"
                >
                  <i className="icon">
                    <img src={productsIcon} alt="" />
                  </i>{" "}
                  Listed Items
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/product-management"
                >
                  <i className="icon">
                    <img src={productsIcon} alt="" />
                  </i>{" "}
                  Product Management
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/quote-management"
                >
                  <i className="icon">
                    <img src={chatSidebarIcon} alt="" />
                  </i>{" "}
                  Quote Management
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/team"
                >
                  <i className="icon">
                    <img src={customersIcon} alt="" />
                  </i>{" "}
                  Team Management
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/service-management"
                >
                  <i className="icon">
                    <img src={serviceSidebarIcon} alt="" />
                  </i>{" "}
                  Service Management
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/projects"
                >
                  <i className="icon">
                    <img src={reportsIcon} alt="" />
                  </i>{" "}
                  My Projects (Services)
                </SideMenuLink>
              </li>
              <li>
                <SideMenuLink
                  to="/seller/product-orders"
                >
                  <i className="icon">
                    <img src={shoppingBagIcon} alt="" />
                  </i>{" "}
                  Product Orders
                </SideMenuLink>
              </li>
              {/* <li>
                <Link
                  to="/seller/service-orders"
                >
                  <i className="icon">
                    <img src={shoppingBagIcon} alt="" />
                  </i>{" "}
                  Service Orders
                </Link>
              </li> */}
              <li>
                <SideMenuLink
                  to="/seller/advertising-subscription"
                >
                  <i className="icon">
                    <img src={bannerIcon} alt="" />
                  </i>{" "}
                  {/* Buy  */}
                  Advertising
                  Subscriptions
                </SideMenuLink>
              </li>
              {/* <li>
                <Link to="/seller/payments">
                  <i className="icon">
                    <img src={creditCardIcon} alt="" />
                  </i>{" "}
                  Payments
                </Link>
              </li> */}
              <li>
                <SideMenuLink to="/seller/support">
                  <i className="icon">
                    <img src={supportSidebarIcon} alt="" />
                  </i>{" "}
                  Support
                </SideMenuLink>
              </li>
              <li>
                <a href="#" role="button" onClick={handleLogoutClick}>
                  <i className="icon">
                    <img src={logoutIcon} alt="" />
                  </i>{" "}
                  Logout
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <header className="header">
        <div className="main_nav seller_dash_nav">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <nav className="navbar navbar-expand-lg py-0">
                  <div className="container-fluid p-0">
                    <div className="side_menu_btn">
                      <button
                        className="btn"
                        type="button"
                        data-bs-toggle="offcanvas"
                        data-bs-target="#sideMenu"
                        aria-controls="sideMenu"
                      >
                        <span className="menu_btn_icon"></span>
                      </button>
                    </div>
                    <Link className="navbar-brand py-0" to="/seller/dashboard">
                      <img src={logo} alt="logo" className="img-fluid h-100" />
                    </Link>
                    <button
                      className="navbar-toggler"
                      type="button"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#offcanvasNavbar"
                      aria-controls="offcanvasNavbar"
                    >
                      <span className="fa fa-bars"></span>
                    </button>
                    <div
                      className="offcanvas offcanvas-end"
                      tabIndex="-1"
                      id="offcanvasNavbar"
                      aria-labelledby="offcanvasNavbarLabel"
                    >
                      <div className="offcanvas-header">
                        <button
                          type="button"
                          className="btn-close text-reset ms-auto"
                          data-bs-dismiss="offcanvas"
                          aria-label="Close"
                        ></button>
                      </div>
                      <div className="offcanvas-body d-block">
                        <ul className="seller_menu navbar-nav justify-content-end flex-grow-1 pe-0">
                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/seller/notifications"
                              onClick={handleNotificationClick}
                            >
                              <div className="sm_icon">
                                <img src={blcakbellIcon} alt="" />
                                {unreadCount > 0 && (
                                  <span className="notification-count">{unreadCount}</span>
                                )}
                              </div>
                              <span>Notifications</span>
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/seller/chat"
                            >
                              <div className="sm_icon">
                                <img src={smChatIcon} alt="" />
                              </div>
                              <span>Chat</span>
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/seller/community"
                            >
                              <div className="sm_icon">
                                <img src={communityIcon} alt="" />
                              </div>
                              <span>Community</span>
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <NavLink
                              className={({ isActive }) =>
                                `nav-link ${isActive ? "active-menu" : ""}`
                              }
                              to="/seller/contact"
                            >
                              <div className="sm_icon">
                                <img src={contactIcon} alt="" />
                              </div>
                              <span>Contact</span>
                            </NavLink>
                          </li>

                          <li className="nav-item">
                            <a href="#" role="button" className="nav-link" onClick={handleLogoutClick}>
                              <div className="sm_icon">
                                <img src={smLogoutIcon} alt="" />
                              </div>
                              <span>Logout</span>
                            </a>
                          </li>

                          {/* Add user profile */}
                          <li className="nav-item dropdown seller-profile-dropdown">
                            <a
                              href="#"
                              className="nav-link dropdown-toggle"
                              id="navbarDropdown"
                              role="button"
                              data-bs-toggle="dropdown"
                              data-bs-auto-close="true"
                              aria-expanded="false"
                              onClick={handleSellerProfileTriggerClick}
                            >
                              <div className="com_user_acc">
                                <div className="com_user_img">
                                  <img
                                    src={
                                      userInfo.imgUrl !== null && userInfo.imgUrl !== ""
                                        ? userInfo.imgUrl
                                        : userImg
                                    }
                                    alt=""
                                  />
                                </div>
                                <div className="com_user_name">
                                  <div className="cu_name">{userInfo.name}</div>
                                  <div>{userInfo.role}</div>
                                </div>
                              </div>
                            </a>
                            <ul
                              className="dropdown-menu dropdown-menu-end seller-profile-dropdown__menu"
                              aria-labelledby="navbarDropdown"
                              data-bs-display="static"
                            >
                              <li className="seller-profile-dropdown__row">
                                <NavLink
                                  to="/seller/myprofile"
                                  className="seller-profile-dropdown__item"
                                  activeClassName="is-active"
                                >
                                  My Profile
                                </NavLink>
                              </li>
                              <InterfaceModeProfileMenuItem
                                targetMode={INTERFACE_MODES.BUYER}
                                variant="dropdown"
                              />
                              <li className="seller-profile-dropdown__row seller-profile-dropdown__row--divider" aria-hidden="true" />
                              <li className="seller-profile-dropdown__row">
                                <NavLink
                                  to="/seller/account"
                                  className="seller-profile-dropdown__item"
                                  activeClassName="is-active"
                                >
                                  Account
                                </NavLink>
                              </li>
                              <li className="seller-profile-dropdown__row seller-profile-dropdown__row--divider" aria-hidden="true" />
                              <li className="seller-profile-dropdown__row">
                                <a
                                  href="#"
                                  role="button"
                                  className="seller-profile-dropdown__item"
                                  onClick={handleLogoutClick}
                                >
                                  Log Out
                                </a>
                              </li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  );
};

export default Header;
